import { Link } from 'react-router-dom';
import { Button, Card, Result } from 'antd';
import { useDocumentTitle } from '../utils/document-head';

export function NotFoundPage() {
  useDocumentTitle('Page not found');
  return (
    <div className="page">
      <Card>
        <Result status="404" title="Page not found" subTitle="The address may be mistyped, or the page has moved." extra={<Link to="/"><Button type="primary">Back to dashboard</Button></Link>} />
      </Card>
    </div>
  );
}

export function ForbiddenPage() {
  useDocumentTitle('Super admins only');
  return (
    <div className="page">
      <Card>
        <Result status="403" title="Super admins only" subTitle="Ask a super admin to manage users and workspace settings." extra={<Link to="/"><Button type="primary">Back to dashboard</Button></Link>} />
      </Card>
    </div>
  );
}
